function SimulatorFormController(stateService, config, $scope) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.simulationOptions = { index: 0, date: new Date() };
    ctrl.stationCurrent = null;
    ctrl.stationDestination = null;
    ctrl.selectedWorkspace = stateService.getSelectedWorkspace();
    ctrl.operator = config.operator;

    ctrl.dateOptions = {
      timeSecondsFormat: 'ss',
      timeStripZeroSeconds: false
    };

    // Wait for async parameter to resolve before trying to update the form
    $scope.$watch(() => ctrl.simulatorScripts, function (newValue, oldValue) {
      if (newValue && ctrl.simulatorScripts && Array.isArray(ctrl.simulatorScripts) && ctrl.simulatorScripts.length === 1) {
         // If only one simulator script available, select it.
        ctrl.simulationOptions.simulatorScript = ctrl.simulatorScripts[0];
      }
    });
  };

  ctrl.trainNumberSelected = () => {
    // Loop through each run and find the one with a train number matching the currently selected train number
    // Train number == PTI.  Train number array also includes runs array (integers).
    // Re-filter the runs based on this array of run ids.

    let runsWithTrainNumbers = [];
    _.each(ctrl.runs, run =>  {
      if (run.train_numbers && run.train_numbers.length >= 0) {
        _.each(run.train_numbers, train => {
          runsWithTrainNumbers.push(train);
        })
      }
    })

    // now resolve the runs for this train == PTI
    let runIdsForPTI; 
    _.each(runsWithTrainNumbers, train => {
      if (train.number === ctrl.simulationOptions.trainNumber.number) {
        runIdsForPTI = train.runs;
      }
    })

    let matchingRuns = [];
    _.each(ctrl.runs, run => {
      if (runIdsForPTI.includes(run.id)) {
        matchingRuns.push(run);
      }
    })
    ctrl.matchingRuns = matchingRuns;
    
    if (matchingRuns.length === 1) {
      // If PTI has only one run, select it and pre-fill all the details
      ctrl.simulationOptions.run = matchingRuns[0];
      ctrl.stationCurrent = matchingRuns[0].stations[0];
      ctrl.stationDestination = matchingRuns[0].stations[matchingRuns[0].stations.length - 1];
      ctrl.runSelected();
    }
  };

  ctrl.runSelected = () => {
    if (!ctrl.simulationOptions.run) {
      ctrl.stationCurrent = null;
      ctrl.stationDestination = null;
      return;
    }

    ctrl.stationCurrent = ctrl.simulationOptions.run.stations[0];
    ctrl.stationDestination = ctrl.getDestinationStation();
    ctrl.simulationOptions.index = 0;
    
    ctrl.simulationOptions.selectedRunId = ctrl.simulationOptions.run.id;

    // Re-set the default run for the train number (PTI code)
    ctrl.simulationOptions.trainNumber.run = ctrl.simulationOptions.run.id;
    stateService.editTrainNumber(ctrl.selectedWorkspace.id, ctrl.simulationOptions.trainNumber.id, ctrl.simulationOptions.trainNumber).then(
      function(response) {
      },
      function(e) {
        console.error(e);
      }
    );
  }

  ctrl.getDestinationStation = () => {
    if (ctrl.simulationOptions && ctrl.simulationOptions.run && ctrl.simulationOptions.run.stations) {
      return ctrl.simulationOptions.run.stations[ctrl.simulationOptions.run.stations.length - 1];
    }
  };

  ctrl.findRun = () => {
    if (ctrl.stationDestination && ctrl.runs) {
      for (const run of ctrl.runs) {
        if (ctrl.stationDestination.id === run.stations[run.stations.length - 1].id) {
          return run;
        }
      }
    }
  };

  ctrl.findTrain = (run) => {
    for (const train of ctrl.trainNumbers) {
      if (train.run === run) {
        return train;
      }
    }
  };

  ctrl.onSubmit = () => {
    const options = angular.copy(ctrl.simulationOptions);
    options.date = DateTime.fromJSDate(options.date).toFormat('MM/dd/yyyy hh:mm:ss a');
    ctrl.onBeginSimulation({
      $event: {
        options: options
      }
    });
  };
}

angular
  .module('pis-tool.module')
  .controller('SimulatorFormController', SimulatorFormController);
